import vClickOutside from "v-click-outside";

export default {
  props: {
    onSelectionChange: {
      type: Function,
    },
    selectedBrands: {
      type: Array,
    },
  },

  data() {
    return {
      brands: [],
      query: "",
      isOpen: false,
      selectedItems: [],
      showLoader: false,
    };
  },
  methods: {
    toggleDropdown,
    closeDropdown,
    selectItem,
    getBrands,
    isItemSelected,
    getFilteredBrands,
    getPlaceholder,
  },

  beforeMount() {
    this.getBrands();
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};

function toggleDropdown() {
  if (this.brands) {
    this.isOpen = !this.isOpen;
  }
}

function closeDropdown() {
  this.isOpen = false;
}

async function getBrands() {
  try {
    this.showLoader = true;
    const { data } = await this.$utils.getAllBrands(true);
    this.brands = data.brands_dropdown;
    this.selectedItems =
      this.selectedBrands && this.brands
        ? this.selectedBrands
            .filter((selectedBrand) => {
              return this.brands?.find((brand) => brand?.id === selectedBrand);
            })
            .map((brandId) => this.brands?.find((brand) => brand?.id === brandId))
        : [];
  } catch (error) {
    this.$swal("Attention", this.$utils.formatErrorMessage("brands"));
  } finally {
    this.showLoader = false;
  }
}

function getFilteredBrands() {
  if (this.query === "") {
    return this.brands;
  }

  return this.brands.filter((item) => item.name.toLowerCase().includes(this.query.toLowerCase()));
}

function selectItem(item) {
  this.isItemSelected(item)
    ? (this.selectedItems = this.selectedItems.filter((brand) => brand.id !== item.id))
    : this.selectedItems.push(item);
  this.onSelectionChange(this.selectedItems.map((item) => item.id));
}

function isItemSelected(item) {
  return this.selectedItems.find((brand) => brand?.id === item?.id);
}

function getPlaceholder() {
  if (!this.selectedItems || !this.selectedItems.length) {
    return "Bulletin Brand Recommendations";
  }
  return `${this.selectedItems.length} Brand${this.selectedItems.length > 1 ? "s" : ""} Selected `;
}
